import { makeAutoObservable } from 'mobx';

import ApiService from '../services/ApiService';
import ErrorUtil from '../utils/ErrorUtil';
import { isStandardPersonalCode } from '../utils/PersonalCodeUtil';

class PopulationRegistryPersonStore {
  public personalCode = '';
  public personName = '';
  public isValidPersonalCode = false;
  public personNameHasError = false;

  constructor(private apiService: ApiService) {
    makeAutoObservable<PopulationRegistryPersonStore, 'apiService'>(this, { apiService: false }, { autoBind: true });
  }

  private setPersonName(personName: string) {
    this.personName = personName;
  }

  public getPopulationRegistryPerson = (): void => {
    this.apiService
      .getPopulationRegistryPerson(this.personalCode)
      .then((person) => {
        this.setPersonName(`${person.firstName} ${person.lastName}`);
      })
      .catch((error) => {
        this.setPersonNameHasError(true);
        ErrorUtil.registerError(error);
      });
  };

  public updatePopulationRegistryPerson(value: string): void {
    this.personalCode = value;
    this.isValidPersonalCode = isStandardPersonalCode(this.personalCode);

    if (this.isValidPersonalCode) {
      this.getPopulationRegistryPerson();
    }
  }

  public personalCodeFieldErrorMessage(errorLabel: string): string {
    return !this.isValidPersonalCode && !!this.personalCode ? errorLabel : null;
  }

  public personNameFieldErrorMessage(errorLabel: string): string {
    return this.personNameHasError ? errorLabel : null;
  }

  public personNameFieldHelpMessage(infoLabel: string): string {
    return !this.personName ? infoLabel : null;
  }

  private setPersonNameHasError(hasError: boolean) {
    this.personNameHasError = hasError;
  }

  get personalCodeFieldInvalid(): boolean {
    return !!this.personalCode && !this.isValidPersonalCode;
  }
}

export default PopulationRegistryPersonStore;
